module.exports = __webpack_public_path__ + "905cdcbbd691fd903dee8db85e402a13.svg";